import { FC } from 'react';
import { useWatch } from 'react-hook-form';

import { B2bInvestorProfileGrid } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/B2bInvestorProfileGrid';
import { B2bInvestorProfileSicavGrid } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileSicavGrid/B2bInvestorProfileSicavGrid';

export const B2bInvestorProfileGridWrapper: FC = () => {
  const grid_template = useWatch({
    name: 'grid_template',
  });

  if (grid_template === 'sicav') {
    return <B2bInvestorProfileSicavGrid />;
  }

  return <B2bInvestorProfileGrid />;
};
